var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 17,
    viewBox: "0 0 13 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9563 4.73127L8.01875 0.793767C7.96926 0.7388 7.90841 0.695241 7.84043 0.666104C7.77244 0.636968 7.69894 0.622949 7.625 0.625017H2C1.7019 0.625892 1.41626 0.7447 1.20547 0.955489C0.994683 1.16628 0.875876 1.45192 0.875 1.75002V15.25C0.875876 15.5481 0.994683 15.8338 1.20547 16.0445C1.41626 16.2553 1.7019 16.3741 2 16.375H11C11.2981 16.3741 11.5837 16.2553 11.7945 16.0445C12.0053 15.8338 12.1241 15.5481 12.125 15.25V5.12502C12.1271 5.05108 12.113 4.97758 12.0839 4.90959C12.0548 4.8416 12.0112 4.78076 11.9563 4.73127ZM7.625 1.97502L10.775 5.12502H7.625V1.97502ZM11 15.25H2V1.75002H6.5V5.12502C6.50088 5.42312 6.61968 5.70876 6.83047 5.91954C7.04126 6.13033 7.3269 6.24914 7.625 6.25002H11V15.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.475 9.15002V8.35002H6.875V7.15002H6.075V8.35002H5.275C5.06289 8.35023 4.85953 8.43459 4.70955 8.58457C4.55956 8.73455 4.47521 8.93791 4.475 9.15002V10.35C4.47521 10.5621 4.55956 10.7655 4.70955 10.9155C4.85953 11.0655 5.06289 11.1498 5.275 11.15H7.675V12.35H4.475V13.15H6.075V14.35H6.875V13.15H7.675C7.88709 13.1498 8.09044 13.0654 8.24041 12.9154C8.39039 12.7655 8.47475 12.5621 8.475 12.35V11.15C8.47478 10.9379 8.39043 10.7346 8.24045 10.5846C8.09046 10.4346 7.8871 10.3502 7.675 10.35H5.275V9.15002H8.475Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatement);
export default __webpack_public_path__ + "static/media/statement.5beab64c4187dcd768c20b1605914ec6.svg";
export { ForwardRef as ReactComponent };